<template>
  <div
    v-tooltip="{
      /* d99d */ content: parsedLastMessage,
      delay: { show: 1200, hide: 0 },
      placement: `bottom-${rtl ? 'end' : 'start'}`,
    }"
    class="overflow-hidden text-ellipsis whitespace-nowrap w-full"
    @click="$emit('click')"
  >
    <woot-delete-modal
      v-if="showDeleteModal"
      class="context-menu--delete-modal"
      :show.sync="showDeleteModal"
      :on-close="closeDeleteModal"
      :on-confirm="confirmDeletion"
      :title="$t('CONVERSATION.CONTEXT_MENU.DELETE_CONFIRMATION.TITLE')"
      :message="$t('CONVERSATION.CONTEXT_MENU.DELETE_CONFIRMATION.MESSAGE')"
      :confirm-text="$t('CONVERSATION.CONTEXT_MENU.DELETE_CONFIRMATION.DELETE')"
      :reject-text="$t('CONVERSATION.CONTEXT_MENU.DELETE_CONFIRMATION.CANCEL')"
    />
    <div
      class="flex"
      :class="{
        'flex-row-reverse': enableDelete,
        'justify-between': enableDelete,
      }"
    >
      <div
        :class="{
          'self-center': enableDelete,
        }"
      >
        <template v-if="showMessageType">
          <fluent-icon
            v-if="isMessagePrivate"
            size="16"
            class="-mt-0.5 align-middle text-slate-600 dark:text-slate-300 inline-block"
            icon="lock-closed"
          />
          <fluent-icon
            v-else-if="messageByAgent"
            size="16"
            class="-mt-0.5 align-middle text-slate-600 dark:text-slate-300 inline-block"
            icon="arrow-reply"
          />
          <fluent-icon
            v-else-if="isMessageAnActivity"
            size="16"
            class="-mt-0.5 align-middle text-slate-600 dark:text-slate-300 inline-block"
            icon="info"
          />
        </template>
        <button @click="openDeleteModal">
          <fluent-icon
            v-if="enableDelete"
            size="16"
            class="-mt-0.5 align-middle text-slate-600 dark:text-slate-300 inline-block"
            icon="delete"
          />
        </button>
      </div>
      <div>
        <span v-if="message.content" v-dompurify-html="parsedLastMessage" />
        <span v-else-if="message.attachments">
          <fluent-icon
            v-if="attachmentIcon && showMessageType"
            size="16"
            class="-mt-0.5 align-middle inline-block text-slate-600 dark:text-slate-300"
            :icon="attachmentIcon"
          />
          {{ $t(`${attachmentMessageContent}`) }}
        </span>
        <span v-else>
          {{ defaultEmptyMessage || $t('CHAT_LIST.NO_CONTENT') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { MESSAGE_TYPE } from 'widget/helpers/constants';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import { ATTACHMENT_ICONS } from 'shared/constants/messages';
import localeMixin from 'shared/mixins/localeMixin';
import alertMixin from '../../../../shared/mixins/alertMixin';

export default {
  name: 'EmailMessagePreview',
  mixins: [messageFormatterMixin, localeMixin, alertMixin /* d99d */],
  props: {
    message: {
      type: Object,
      required: true,
    },
    showMessageType: {
      type: Boolean,
      default: true,
    },
    defaultEmptyMessage: {
      type: String,
      default: '',
    },
    additionalAttributes: {
      type: Object,
      default: () => {},
    },
    enableDelete: {
      type: Boolean,
      default: false,
    },
    showSubject: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDeleteModal: false,
    };
  },
  computed: {
    subject() {
      const { content_attributes: contentAttributes } = this.message;
      const { email: { subject } = {} } = contentAttributes || {};

      return this.additionalAttributes?.mail_subject || subject;
    },
    messageByAgent() {
      const { message_type: messageType } = this.message;
      return messageType === MESSAGE_TYPE.OUTGOING;
    },
    isMessageAnActivity() {
      const { message_type: messageType } = this.message;
      return messageType === MESSAGE_TYPE.ACTIVITY;
    },
    isMessagePrivate() {
      const { private: isPrivate } = this.message;
      return isPrivate;
    },
    parsedLastMessage() {
      return this.formatMessage(
        this.showSubject
          ? this.subject || this.message.content
          : this.message.content,
        false,
        true,
        true
      ).replace(/<\/?[^>]+>/gi, ' ');
    },
    lastMessageFileType() {
      const [{ file_type: fileType } = {}] = this.message.attachments;
      return fileType;
    },
    attachmentIcon() {
      return ATTACHMENT_ICONS[this.lastMessageFileType];
    },
    attachmentMessageContent() {
      return `CHAT_LIST.ATTACHMENTS.${this.lastMessageFileType}.CONTENT`;
    },
  },
  methods: {
    openDeleteModal() {
      console.log(';l;;');
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    async confirmDeletion() {
      try {
        await this.$store.dispatch('deleteMessage', {
          conversationId: this.message.conversation_id,
          messageId: this.message.id,
        });
        this.showAlert(this.$t('CONVERSATION.SUCCESS_DELETE_MESSAGE'));
      } catch (error) {
        this.showAlert(this.$t('CONVERSATION.FAIL_DELETE_MESSSAGE'));
      } finally {
        this.closeDeleteModal();
      }
    },
  },
};
</script>
